(function () {
	'use strict';

	/**
	 * @ngdoc component
	 * @name mx.SolutionBuilderAgent:mxSearchQueryConditionExpression
	 * @module mx.SolutionBuilderAgent
	 * @requires $scope
	 * @requires <a href="https://github.com/Matrix42AG/Pandora/wiki/mx.shell.UserProfileService">mx.shell.UserProfileService<a>
	 * @description
	 * A search query condition that displays conditions as expressions
	 * @param {SearchQueryCondition} condition= - related {@ref SearchQueryCondition} instance
	 * @usage <mx-search-query-condition-expression data-condition="vm.condition" data-condition-operators="vm.operators"></mx-search-query-condition-expression>
	 */
	angular.module('mx.SolutionBuilderAgent').component('mxSearchQueryConditionExpression', {
		bindings: {
			condition: '<',
			operators: '<',
			className: '@',
		},
		controller: MxSearchQueryConditionExpressionController,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-search-query-condition/by-type/mx-search-query-condition-expression.html',
	});

	MxSearchQueryConditionExpressionController.$inject = ['mx.shell.UserProfileService', '$scope'];

	function MxSearchQueryConditionExpressionController(userProfileService, $scope) {
		var vm = this;

		vm.$onInit = function () {
			userProfileService.isCustomizationMode().then(function (result) {
				vm.showExpression = result;
			});

			if (vm.condition) {
				vm.condition.value = Array.isArray(vm.condition.value) ? [vm.condition.value[0] || '', vm.condition.value[1] || ''] : ['', ''];
			}
		};

		var w = $scope.$watchGroup(['vm.condition.value[0]', 'vm.condition.value[1]'], updateConditionValidity);
		$scope.$on('$destroy', () => w());
		return vm;

		function updateConditionValidity(newValues) {
			vm.condition.__valid = Boolean(newValues[0]) && Boolean(newValues[1]);
		}
	}
})();
